import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PlayerModel } from '../models/player.model';
import { TeamModel } from '../models/team.model';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private _activeProfileSubject: BehaviorSubject<PlayerModel | TeamModel | any | null> = new BehaviorSubject<PlayerModel | TeamModel | any | null>(null);
  activeProfile$: Observable<PlayerModel | TeamModel | any | null> = this._activeProfileSubject.asObservable();

  constructor() { }

  setActiveProfile(profile: PlayerModel | TeamModel | any | null): void {
    this._activeProfileSubject.next(profile);
  }

  get activeProfile(): PlayerModel | TeamModel | any | null {
    return this._activeProfileSubject.value;
  }
}
